import React, { forwardRef, useMemo, useState } from 'react'
import FontAwesome from 'react-native-vector-icons/MaterialCommunityIcons'
import {
  useInputValidateInput,
  useTheme,
  withEditableConverter,
} from '../hooks'
import { BtInput, BtInputProps } from './BtInput'

const RightComponent = ({
  secureTextEntry,
  setSecureTextEntry,
  editable = true,
}) => {
  const theme = useTheme()
  if (!editable) return null

  return (
    <FontAwesome
      name={secureTextEntry ? 'eye' : 'eye-off'}
      size={20}
      style={{ marginRight: 10 }}
      onPress={() => setSecureTextEntry(!secureTextEntry)}
      color={theme['text-hint-color']}
    />
  )
}

export const BtMaskedInputBase = forwardRef(
  (
    {
      style,
      inputMask,
      maxLength = 11,
      onChangeText,
      disabled,
      errorText: initialError,
      toRemoveRegex,
      onFocus,
      onBlur,
      value,
      validateInput,
      ...props
    }: BtInputProps,
    ref: React.Ref<any>,
  ) => {
    const [error, setError] = React.useState(initialError)
    const [secureTextEntry, setSecureTextEntry] = useState(false)

    const [mask, setMask] = useState(
      !value && inputMask ? inputMask : undefined,
    )

    const handleMaskedStringChange = useMemo(
      () => (val) => {
        if (val.includes('*')) {
          onChangeText && onChangeText(val.replace('*', ''))
          setMask(inputMask ?? '')
        }

        // Sometime when state reloads etc with value it might not mask properly.
        if (value && !mask) setMask(inputMask)
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [onChangeText, setMask, inputMask],
    )

    const newOnChangeText = useInputValidateInput({
      validateInput,
      onChangeText,
      setError,
      handleMaskedStringChange,
      toRemoveRegex,
    })

    return (
      <BtInput
        secureTextEntry={secureTextEntry}
        rightComponent={
          <RightComponent
            secureTextEntry={secureTextEntry}
            setSecureTextEntry={setSecureTextEntry}
            editable={disabled}
          />
        }
        onFocus={(e) => {
          setSecureTextEntry(false)
          onFocus && onFocus(e)
        }}
        onBlur={(e) => {
          setSecureTextEntry(true)
          onBlur && onBlur(e)
        }}
        value={value}
        errorText={error}
        inputMask={mask || new Array(maxLength).join('*')}
        ref={ref}
        onChangeText={newOnChangeText}
        {...props}
      />
    )
  },
)

export const BtMaskedInput = withEditableConverter(BtMaskedInputBase)
